import axios from 'axios';
import HttpHelper from '../helper/HttpHelper';

class OrderListService {

    getAll(payload) {
        return axios.get(HttpHelper.API_URL + '/order-lists', { params: payload }, HttpHelper.getHeader());
    }

    getOne(id, payload) {
        return axios.get(HttpHelper.API_URL + '/order-lists/' + id, { params: payload }, HttpHelper.getHeader());
    }

    create(payload) {
        return axios.post(HttpHelper.API_URL + '/order-lists', payload, HttpHelper.getAuthHeader());
    }

    update(id, payload) {
        return axios.put(HttpHelper.API_URL + "/order-lists/" + id, payload, HttpHelper.getAuthHeader());
    }

    delete(id) {
        return axios.delete(HttpHelper.API_URL + "/order-lists/" + id, HttpHelper.getAuthHeader());
    }

}

export default OrderListService = new OrderListService();